import { render } from "./aboutFamily.vue?vue&type=template&id=5b1a4a44"
import script from "./aboutFamily.vue?vue&type=script&lang=js"
export * from "./aboutFamily.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__